export const GET_CURRENT_USER_DASHBOARD = 'GET_CURRENT_USER_DASHBOARD';
export const GET_GROUP_DASHBOARD = 'GET_GROUP_DASHBOARD';
export const GET_GROUP_MEMBER_DASHBOARD = 'GET_GROUP_MEMBER_DASHBOARD';
